import LoadingSpinner from "../Loading/LoadingSpinner";
import Modal from "../Modal/Modal";
import Pagination from "../Pagination/Pagination";
import PokemonCard from "../PokemonCard/PokemonCard";
import "./index.css";

function Card({
  pokemons,
  loading,
  error,
  nextPageUrl,
  prevPageUrl,
  pokemonName,
  showModal,
  setShowModal,
  gotoNextPage,
  gotoPrevPage,
  handleModal,
}) {
  return (
    <>
      {!loading ? (
        <div className="card-area">
          {error ? <p>Failed to load pokemon list.</p> : null}
          {pokemons?.map((pokecard) => (
            <PokemonCard
              key={pokecard.name}
              pokemonName={pokecard.name}
              onClick={() => handleModal(pokecard.name)}
            />
          ))}
        </div>
      ) : (
        <LoadingSpinner ariaLabel="pokemon-list-loading" />
      )}

      {showModal ? (
        <Modal setShowModal={setShowModal} pokemonName={pokemonName} />
      ) : null}

      <Pagination
        gotoNextPage={nextPageUrl ? gotoNextPage : null}
        gotoPrevPage={prevPageUrl ? gotoPrevPage : null}
      />
    </>
  );
}

export default Card;
